import { render } from "./App.vue?vue&type=template&id=a05bf718&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a05bf718&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05bf718"]])

export default __exports__